"use client";
import React from "react";
import { ButtonCta } from "@/components";

const gallery = [
  { src: "/images/IMG_3908.webp", cls: "row-span-2" },
  { src: "/images/_BOP4086.webp", cls: "" },
  { src: "/images/861A8191.webp", cls: "" },
  { src: "/images/_BOP6270.webp", cls: "row-span-2" },
  { src: "/images/IMG_3884.webp", cls: "" },
  { src: "/images/award-2.webp", cls: "" },
];

const press = ["Forbes", "NBC", "TEDx", "ABC", "Marriott"];

export default function AuthorsSpotlight() {
  return (
    <section className="relative overflow-hidden bg-paper px-4 py-20 md:px-8">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 lg:grid-cols-2">
        {/* Intro */}
        <div data-aos="fade-right">
          <span className="eyebrow flex items-center gap-3 text-gold-deep">
            <span className="h-px w-8 bg-gold/70" />
            Recognized & Celebrated
          </span>
          <h2 className="mt-5 font-display text-[clamp(1.9rem,4vw,3rem)] font-semibold leading-[1.1] text-ink">
            Ready to See Your Story on Shelves?
          </h2>
          <p className="mt-5 text-ink-soft">
            From award recognition to national press, our authors don't just
            publish a book — they get noticed. Yours could be next.
          </p>

          <div className="mt-8">
            <p className="eyebrow text-ink-soft">As Featured In</p>
            <div className="mt-3 flex flex-wrap items-center gap-x-6 gap-y-3">
              {press.map((p) => (
                <span key={p} className="font-display text-xl font-semibold text-ink/40 transition-colors hover:text-brand-600">
                  {p}
                </span>
              ))}
            </div>
          </div>

          <div className="mt-9">
            <ButtonCta buttonText="Get Published Today" classStyle="text-white bg-brand-600 hover:bg-brand-700 h-12" />
          </div>
        </div>

        {/* Gallery */}
        <div className="grid auto-rows-[130px] grid-cols-3 gap-4" data-aos="fade-left">
          {gallery.map((g, i) => (
            <div
              key={i}
              className={`group overflow-hidden rounded-2xl ring-1 ring-ink/10 ${g.cls}`}
            >
              <img loading="lazy" decoding="async"
                src={g.src}
                alt="Award-winning author"
                className="h-full w-full object-cover object-[center_25%] transition-transform duration-700 group-hover:scale-110"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
